import { Divider, Input, InputNumber, Modal } from "antd";
import React from "react";
import disputeIcon from "../../assets/images/disputeIcon.svg";
import { injectIntl } from "react-intl";
import { CLAIM_TYPE } from "../../utils/Helper";
import { COLORS } from "../../constants/colors";

const claimTypeStyle = (active) => ({
  cursor: "pointer",
  flex: 1,
  textAlign: "center",
  padding: "6px 0",
  borderRadius: 8,
  border: `1px solid ${active ? COLORS.PRIMARY : COLORS.BORDER}`,
  color: active ? COLORS.PRIMARY : undefined,
  fontWeight: active ? 600 : 400,
});

const confirmStyle = (disabled) => ({
  cursor: disabled ? "not-allowed" : "pointer",
  color: COLORS.PRIMARY,
  opacity: disabled ? 0.5 : 1,
});

const DisputeModal = ({
  intl,
  visible,
  title,
  description,
  setReason,
  cancelAction,
  confirmAction,
  cancelText,
  confirmText,
  claimType,
  setClaimType,
  claimedAmount,
  setClaimedAmount,
  maxClaimAmount = 0,
  claimError = "",
  confirmDisabled = false,
}) => {
  const isFull = claimType === CLAIM_TYPE.FULL;
  return (
    <Modal open={visible} footer={null} onCancel={cancelAction}>
      <div className="d-flex flex-column" style={{ fontFamily: "Poppins" }}>
        <div className="d-flex justify-content-center align-items-center">
          <img
            src={disputeIcon}
            width={25}
            height={25}
            alt=""
            className="mt-3 mx-2"
          />
          <span
            className="d-flex justify-content-center mt-3 mb-1 fs-5 fw-bold "
            style={{ color: COLORS.PRIMARY }}
          >
            {title}
          </span>
        </div>
        <p className="text-center mb-4 fs-6">{description}</p>

        <Input.TextArea
          rows={7}
          placeholder={intl.formatMessage({ id: "ENTER_DISPUTE_REASON" })}
          onChange={(e) => {
            setReason(e?.target?.value);
          }}
        />

        {setClaimType ? (
          <div className="mt-3">
            <div className="d-flex" style={{ gap: 8 }}>
              <div
                onClick={() => setClaimType(CLAIM_TYPE.FULL)}
                style={claimTypeStyle(isFull)}
              >
                {intl.formatMessage({ id: "DISPUTE_CLAIM_FULL" })}
              </div>
              <div
                onClick={() => setClaimType(CLAIM_TYPE.PARTIAL)}
                style={claimTypeStyle(!isFull)}
              >
                {intl.formatMessage({ id: "DISPUTE_CLAIM_PARTIAL" })}
              </div>
            </div>

            {isFull ? (
              <p className="text-center mt-2 mb-0">
                {intl.formatMessage(
                  { id: "DISPUTE_CLAIM_FULL_HINT" },
                  { amount: maxClaimAmount.toFixed(2) }
                )}
              </p>
            ) : (
              <div className="mt-2">
                <InputNumber
                  className="w-100"
                  min={0}
                  max={maxClaimAmount || undefined}
                  precision={2}
                  prefix="$"
                  value={claimedAmount}
                  onChange={setClaimedAmount}
                  placeholder={intl.formatMessage({
                    id: "DISPUTE_CLAIM_AMOUNT_LABEL",
                  })}
                />
              </div>
            )}

            {claimError ? (
              <p className="text-center mt-2 mb-0" style={{ color: COLORS.DANGER }}>
                {claimError}
              </p>
            ) : null}

            <p className="text-center mt-2 mb-0" style={{ fontSize: 12 }}>
              {intl.formatMessage({ id: "DISPUTE_CLAIM_NOTE" })}
            </p>
          </div>
        ) : null}

        <Divider />

        <div className="d-flex justify-content-around fw-bold">
          {cancelText ? (
            <>
              <div
                onClick={cancelAction}
                style={{ cursor: "pointer", color: COLORS.PRIMARY }}
              >
                <span>{cancelText}</span>
              </div>
            </>
          ) : null}
          <Divider type={"vertical"} style={{ height: 25 }} />
          {confirmText ? (
            <div
              onClick={confirmDisabled ? undefined : confirmAction}
              style={confirmStyle(confirmDisabled)}
            >
              <span>{confirmText}</span>
            </div>
          ) : null}
        </div>
      </div>
    </Modal>
  );
};

export default injectIntl(DisputeModal);
